module.exports = __webpack_public_path__ + "static/media/blackberry.e913af88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blackberry.svg
// module id = 714
// module chunks = 11